<template>
  <div class="component-wrapper">
    <v-container v-if="!contactSent">

      <p class="text-muted">Even if you would like to <b>schedule a meeting</b> or you are interested at <b>viewing a demo</b>,
        you can fill this form and we will reach you ASAP</p>
        <v-form ref="contactForm" v-model="formIsValid" lazy-validation >
          <v-row>
            <v-col>
              <v-text-field required :rules="rules.nonEmpty" label="Name" v-model="name"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field required :rules="rules.nonEmpty" label="Surname" v-model="surname"></v-text-field>
            </v-col>
            <v-col>
              <v-text-field required :rules="rules.nonEmpty && rules.validEmail" label="Your email" v-model="email"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea required :rules="rules.nonEmpty" label="Comments" v-model="comments"></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
              color="primary darken-2"
              :disabled="!formIsValid"
              @click="submit"
              >Submit</v-btn>
            </v-col>
          </v-row>
        </v-form>

    </v-container>
    <v-flex v-else>
      <p><strong>Thank you for getting in touch! </strong></p>
      <p>We appreciate you contacting us. One of our colleagues will get back in touch with you soon!</p>

      <p>Stay safe!</p>
    </v-flex>
  </div>
</template>

<script>

import mailApi from '@/api';

  export default {
    name:'Contact',
    data: () => ({
      name: null,
      surname: null,
      email: null,
      comments: null,
      platform: process.env.VUE_APP_PLATFORM,
      rules: {
        nonEmpty: [val => (val || '').length > 0 || 'This field is required'],
        validEmail: [
          value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.';
          },
        ]
      },
      formIsValid: false,
      contactSent: false,
    }),
    methods: {
      submit(){
        const payload = {
          "name" : this.name,
          "surname" : this.surname,
          "replyto": this.email,
          "email" : this.email,
          "comments" : this.comments,
          "subject": `New contact for ${this.platform}`,
        };
        if (this.$refs.contactForm.validate()){
          this.$gtag.event('contactForm', { source: this.platform });
          mailApi.contacts.sendContact(payload)
          .then(() => {
            this.contactSent = true;
          });
        }
      }
    }
  }
</script>

<style lang="css">
</style>
